/**
 * Safe date formatter that never throws.
 * iOS Safari sometimes fails to parse ISO strings with microseconds,
 * returning Invalid Date. Calling Intl.DateTimeFormat.format() on an
 * Invalid Date throws RangeError and crashes the React tree.
 */
export const formatDateSafe = (value, options = { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }, locale = "fr-FR") => {
  if (!value) return "";
  try {
    // Normalize: strip microseconds beyond milliseconds if present.
    // iOS Safari can't handle more than 3 digits after the dot.
    const cleaned = typeof value === "string"
      ? value.replace(/\.(\d{3})\d+/, ".$1")
      : value;
    const d = new Date(cleaned);
    if (isNaN(d.getTime())) return "";
    return new Intl.DateTimeFormat(locale, options).format(d);
  } catch {
    return "";
  }
};
